__webpack_require__.p = "/postal-card-collection/";